import React, { Component, PropTypes } from 'react';
import truncate from 'lodash/truncate';
import classnames from 'classnames';
import { getParticipantEmail } from 'focus_groups/utils';
import { WEIGHT_OPTIONS } from 'focus_groups/utils';

export default class ParticipantRow extends Component {

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onRemove = this.onRemove.bind(this);
  }

  onChange(e) {
    const { id, onChange } = this.props;
    onChange(id, e.target.value * 1);
  }

  onRemove() {
    const { id, onRemove } = this.props;
    onRemove(id);
  }

  render() {
    const { email, has_voted, weight, isWeighted } = this.props;
    const participantEmail = getParticipantEmail(email);
    const votedClass = classnames(has_voted?
      'fa fa-check-circle has-voted text-success' : 'fa fa-times text-danger'
    );

    return (
      <tr>
        <td className="participant-email">
          <span className="show-for-small-only">{ truncate(participantEmail, { length: 15 }) }</span>
          <span className="hide-for-small-only">{ participantEmail }</span>
        </td>
        { isWeighted &&
        <td>
          <div className="form-group">
            <div className="select-wrapper">
              <select className="form-control" onChange={this.onChange} value={weight}>
                {WEIGHT_OPTIONS.map((option, i) => (
                  <option key={i} value={option.field}>{option.label}</option>
                ))}
              </select>
            </div>
          </div>
        </td> }
        <td className="text-center"><i className={votedClass} /></td>
        <td className="text-center"><button onClick={this.onRemove} className="btn btn-icon-only"><i className="fa fa-trash"/></button></td>
      </tr>
    );
  }
}

ParticipantRow.propTypes = {
  id: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  has_voted: PropTypes.bool.isRequired,
  weight: PropTypes.number.isRequired,

  isWeighted: PropTypes.bool.isRequired,
  onRemove: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./focus_groups/components/participant_row.jsx